import React from 'react'
import Spinner from '../../Spinner/spinner';
import { ToastContainer } from "react-toastify";
import PaginationCom from '../../Pagination/pagination';
import { Button } from '@mui/material';
import { Modal } from 'react-bootstrap';
import UseLeadList from './Hooks/useLeadList';

const CustomPlanList = () => {
  const {
    list,
        setPage,
        setShow,
        navigate,
        teamList,
        closeLead,
        setLeadId,
        reopenLead,
        assignTeam,
        deleteLead,
        completeLead,
        handleChange,
        setLeadDetails,
        setAssignMember,
        convertToProvider,
        teamListData,
        assignMember,
        countryData,
        PER_PAGE,
        listData,
        spinner,
        filter,
        show,
        page,
        count,
  } = UseLeadList()
  return (
    <section>
      <ToastContainer />
      {spinner ? <Spinner /> : null}
      <div className="m-t-3 cus-padd cusheight">
        <header>
          <h2 className="page-tittle">Lead List</h2>
          <hr />
        </header>
        <p>Total Lead : {listData?.length}</p>
        <div className='d-flex justify-content-end align-item-center'>
          <div className='me-2'>
            <select className='form-select' name='country' onChange={(e) => { handleChange(e) }} value={filter.country}>
              <option hidden>Country</option>
              {
                countryData?.map((item, index) =>
                  <option value={item._id}>{item.name}</option>

                )}
            </select>
          </div>
          <div className='me-2'>
            <select className='form-select' name='provider' onChange={(e) => { handleChange(e) }} value={filter.provider}>
              <option hidden>Provider</option>
              <option value={true}>Active</option>
              <option value={false}>In-Active</option>
            </select>
          </div>
          <div className='me-2'>
            <select className='form-select' name='deleted' value={filter.deleted} onChange={(e) => { handleChange(e) }}>
              <option hidden>Deleted</option>
              <option value={true}>Deleted</option>
              <option value={false}>Not Deleted</option>
            </select>
          </div>
          <div className='me-2'>
            <input type="text" className='form-control' name='leadNumber' value={filter.leadNumber} onChange={(e) => { handleChange(e) }} placeholder='Search by lead number' />

          </div>
          <div className='me-2'>
            <input type="text" className='form-control' name='searchText' value={filter.searchText} onChange={(e) => { handleChange(e) }} placeholder='Search by business name/email' />
          </div>
          <div>
            <button className='btn btn-primary me-2' onClick={list}>Search</button>
            <button className='btn btn-dark me-2' onClick={() => { window.location.reload() }}>Reset</button>
            <button className='btn btn-dark' onClick={() => navigate(`add-lead`)}>Add Lead</button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table   mt-3">
            <thead className="table-dark">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Lead Number</th>
                <th scope="col">Contact Person</th>
                <th scope="col">Business Name</th>
                <th scope="col">Email</th>
                <th scope="col">Mobile</th>
                <th scope="col">Country</th>
                <th scope="col">Dealing person</th>
                <th scope="col">Lead Type</th>
                <th scope="col">Status</th>
                <th scope="col">Origin</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody className='text-center'>
              {
                !listData?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                  :
                  listData?.map((item, index) => {
                    return (
                      <>
                        <tr key={index}>
                          <th style={{ padding: "0.4rem .5rem" }} scope="row">
                            {PER_PAGE * (page - 1) + index + 1}
                          </th>
                          <td style={{ padding: "0.4rem .5rem" }}>{item?.leadNumber}</td>
                          <td style={{ padding: "0.4rem .5rem" }}>{item?.name}</td>
                          <td style={{ padding: "0.4rem .5rem" }}>{item?.providerName}</td>
                          <td style={{ padding: "0.4rem .5rem" }}>{item?.email}</td>
                          <td style={{ padding: "0.4rem .5rem" }}>{item?.mobileNo}</td>
                          <td style={{ padding: "0.4rem .5rem" }}>{item?.country}</td>
                          <td style={{ padding: "0.4rem .5rem" }}>{item?.dealingPerson ? item?.dealingPerson : '-'}</td>
                          <td style={{ padding: "0.4rem .5rem" }}>{item?.leadType}</td>
                          <td style={{ padding: "0.4rem .5rem" }}>{item?.status}</td>
                          <td style={{ padding: "0.4rem .5rem" }}>{item?.origin}</td>
                          <td style={{ padding: "0.4rem .5rem" }}>
                            <Button variant="text" sx={{ color: 'black', fontSize: '12px' }} id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                              <i className="fa-solid fa-ellipsis-vertical cursor"></i>
                            </Button>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                              <a className="dropdown-item cursor" onClick={() => { navigate(`edit-lead/${item?._id}`) }}>Edit Lead</a>
                              <a className="dropdown-item cursor" onClick={() => { setShow(true); teamList(); setLeadDetails(item); setAssignMember(item?.dealingPersonId) }}>Assign Team</a>
                              {
                                item.isProvider ?
                                  <a className="dropdown-item" style={{ color: '#98969682' }}>Convert to provider </a>
                                  :
                                  <a className="dropdown-item cursor" data-bs-toggle="modal" data-bs-target="#convertToProvider" onClick={() => setLeadId(item?._id)}>Convert to provider </a>
                              }

                              <a className="dropdown-item cursor" data-bs-toggle="modal" data-bs-target="#completeLead" onClick={() => setLeadId(item?._id)}>Mark as completed </a>
                              <a className="dropdown-item cursor" data-bs-toggle="modal" data-bs-target="#closeLead" onClick={() => setLeadId(item?._id)}>Mark as Closed </a>
                              <a className="dropdown-item cursor" data-bs-toggle="modal" data-bs-target="#reopenLead" onClick={() => setLeadId(item?._id)}>Re-Open</a>
                              <a className="dropdown-item cursor" data-bs-toggle="modal" data-bs-target="#deleteLead" onClick={() => setLeadId(item?._id)}>Delete</a>
                              <a className="dropdown-item cursor" onClick={() => navigate(`lead-history/${item?._id}`)}>Lead History</a>
                            </ul>
                          </td>
                        </tr>
                      </>
                    );
                  })}
            </tbody>
          </table>
        </div>
        <div className='w-100 d-flex justify-content-center mt-2 mb-5'>
          {!listData?.length ? null : count > 10 &&
            <PaginationCom setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
          }
        </div>
      </div>
      {/* Modal assign lead to team */}
      <Modal centered show={show} onHide={() => setShow(false)}>
        <div className="modal-body">
          <h5 className='text-center mt-2 '>Assign Lead</h5>
          <div>
            <label className="form-label">Team *</label>

            <select className='form-select' name="" id="" onChange={(e) => setAssignMember(e.target.value)} value={assignMember}>
              <option value="">Select Team</option>
              {
                teamListData?.map((item, index) =>
                  <option value={item.marketingTeamId} key={index}>{item.name}</option>
                )
              }
            </select>
          </div>
          <div className='d-flex justify-content-center mt-5'>
            <button type='button' className='btn yesbtn' onClick={() => assignTeam()}>Submit</button>
          </div>
        </div>
      </Modal>
      {/* Modal convert to provider */}
      <div className="modal fade" id="convertToProvider" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <p>Are you sure !</p>
              <p>You want to convert to provider
              </p>
              <button type="button" className="btn nobtn" data-bs-dismiss="modal">No</button>
              <button type="button" onClick={() => convertToProvider()} className="btn yesbtn" data-bs-dismiss="modal">Yes</button>
            </div>

          </div>
        </div>
      </div>
      {/* Modal close lead */}
      <div className="modal fade" id="closeLead" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <p>Are you sure !</p>
              <p>You want to close this lead</p>
              <button type="button" className="btn nobtn" data-bs-dismiss="modal">No</button>
              <button type="button" onClick={() => closeLead()} className="btn yesbtn" data-bs-dismiss="modal">Yes</button>
            </div>

          </div>
        </div>
      </div>
      {/* Modal close lead */}
      <div className="modal fade" id="reopenLead" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <p>Are you sure !</p>
              <p>You want to re-open this lead</p>
              <button type="button" className="btn nobtn" data-bs-dismiss="modal">No</button>
              <button type="button" onClick={() => reopenLead()} className="btn yesbtn" data-bs-dismiss="modal">Yes</button>
            </div>

          </div>
        </div>
      </div>
      {/* Modal complete lead */}
      <div className="modal fade" id="completeLead" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <p>Are you sure !</p>
              <p>You want to complete this lead</p>
              <button type="button" className="btn nobtn" data-bs-dismiss="modal">No</button>
              <button type="button" onClick={() => completeLead()} className="btn yesbtn" data-bs-dismiss="modal">Yes</button>
            </div>

          </div>
        </div>
      </div>
      {/* Modal Delete lead */}
      <div className="modal fade" id="deleteLead" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <p>Are you sure !</p>
              <p>You want to delete this lead</p>
              <button type="button" className="btn nobtn" data-bs-dismiss="modal">No</button>
              <button type="button" onClick={() => deleteLead()} className="btn yesbtn" data-bs-dismiss="modal">Yes</button>
            </div>

          </div>
        </div>
      </div>
    </section>
  )
}

export default CustomPlanList